export default {
  setNetworkOnline: (state, value) => (state.networkOnLine = value),
  setNewContentAvailable: (state, value) => (state.newContentAvailable = value),
  setShowAddToHomeScreenModalForApple: (state, value) => (state.showAddToHomeScreenModalForApple = value),
  updateCurrentStep: (state, value) => (state.currentStep = value),
  updateURL: (state, value) => (state.url = value),
  updateCompetitors: (state, value) => (state.competitors = value),
  updateCompetitorByDomain: (state, payload) => {

    const { uuid, keyword } = payload;
    
    let competitors = state.competitors[keyword];
    
    competitors = competitors.map(c => {
      if(c.uuid === uuid)
        c = {...c, ...payload.data}

      return c
    });

    state.competitors[keyword] = competitors
  },
  appendCompetitorError: (state, value) => {
    console.log(value);

    state.competitorErrors.push(value)
  },
  updateErrorMessage: (state, value) => (state.errors = value),
  updateClientIp: (state, ip) => (state.clientIp = ip),
}
